import http_config from '../../common/config/http_config';
import axiosInstance from '../../common/helper/axiosInterceptor';
import { ExamTypeModel, ExamYearModel } from './exam.model';

export const onGetExamType = (): Promise<ExamTypeModel[]> => {
  return axiosInstance.get(http_config.BASE_URL + '/exam-type');
};

export const onGetExamYear = (): Promise<ExamYearModel[]> => {
  return axiosInstance.get(http_config.BASE_URL + '/exam-year');
};
